import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView } from "src/pages/sistema/components/FieldView";
import { OperacionADCMFields } from "../types/fields";
import { numberFormatter } from "src/utils/formatters/numberFormatter";

type SeccionADCMUnderwritingProps = {
  operacion?: any;
}

const SeccionADCMUnderwriting = ({ operacion }: SeccionADCMUnderwritingProps) => {
  const tieneUnderwriting = operacion?.[OperacionADCMFields.Underwriting];

  if (!operacion || !tieneUnderwriting) return null;

  return (
    <CardActions title='Detalle de Underwriting' icon='mdi:shield-check-outline' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        <Grid item xs={12} md={4}>
          <FieldView
            label='Underwriting - Monto'
            value={operacion[OperacionADCMFields.UnderWritingMonto]
              ? numberFormatter.toStringWithAmount(operacion[OperacionADCMFields.UnderWritingMonto], '$', 0)
              : undefined}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldView
            label='Underwriting - Fee'
            value={operacion[OperacionADCMFields.UnderWritingFee]
              ? numberFormatter.toStringWithAmount(operacion[OperacionADCMFields.UnderWritingFee], '$', 0)
              : undefined}
          />
        </Grid>

        <Grid item xs={12}>
          <FieldView label='Observaciones / Condiciones particulares' value={operacion[OperacionADCMFields.UnderWritingObservaciones]} />
        </Grid>

      </Grid>
    </CardActions>
  );
};

export default SeccionADCMUnderwriting;
